import { resetFeedback } from '../../../actions/feedbackChatbotModal';
import { fetchSetRating } from '../../../services/chatbotFeedback/fetchSetRating';
import { showAlert } from '../../../slices/alertSlice';
import { EAlert } from '../../../types/alert';
import { TThunkAction } from '../../../types/redux/thunk';

export const setRating =
  (rating: number, comment?: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const result = await fetchSetRating(context, rating, comment);

    dispatch(
      showAlert({
        type: EAlert.Info,
        message: `${result ? 'Спасибо за вашу оценку!' : 'Произошла ошибка. Попробуйте позже'}`,
      }),
    );

    if (result) {
      dispatch(resetFeedback());
    }
  };
